export default __webpack_public_path__ + "static/media/banner-vector.d1966b5c.png";